import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  useTheme,
} from "@mui/material";
import PropTypes from "prop-types";

export default function FormLeaveConfirmDialog({
  open,
  onConfirm,
  onCancel,
  formTitle = "Log an Activity",
}) {
  const theme = useTheme();
  const green = theme.palette.green?.main || "#00A59B";

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontWeight: 700 }}>Leave form?</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Do you want to leave the &ldquo;{formTitle}&rdquo; form?
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
        <Button onClick={onConfirm} variant="outlined" color="primary">
          Yes
        </Button>
        <Button
          onClick={onCancel}
          variant="contained"
          autoFocus
          sx={{
            backgroundColor: green,
            "&:hover": { backgroundColor: green, filter: "brightness(0.92)" },
          }}
        >
          No
        </Button>
      </DialogActions>
    </Dialog>
  );
}

FormLeaveConfirmDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  formTitle: PropTypes.string,
};
